import { fetchFromAPI } from 'utils/api';

export const fetchFarm = (id) => {
  return fetchFromAPI(`/farms/${id}`)
    .then((response) => response.resource)
    .catch((response) => {
      throw response;
    });
};

export const getFarmBarns = (id) => {
  return fetchFromAPI(`/farms/${id}/barns`)
    .then((response) => response.resources)
    .catch(() => []);
};

export const getFarmBins = (id) => {
  return fetchFromAPI(`/farms/${id}/bins`)
    .then((response) => response.resources)
    .catch(() => []);
};

// Bin management endpoints
export const getFarmBinsAdmin = (farmId, params = {}) => {
  return fetchFromAPI(`/admin/farms/${farmId}/bins`, { params })
    .then((response) => response)
    .catch((error) => { throw error; });
};

export const createFarmBin = (farmId, binData) => {
  return fetchFromAPI(`/admin/farms/${farmId}/bins`, {
    method: 'POST',
    body: JSON.stringify({ resource: binData })
  }).then((response) => response.resource);
};

export const updateFarmBin = (farmId, binId, binData) => {
  return fetchFromAPI(`/admin/farms/${farmId}/bins/${binId}`, {
    method: 'PUT',
    body: JSON.stringify({ resource: binData })
  }).then((response) => response.resource);
};

export const deleteFarmBin = (farmId, binId) => {
  return fetchFromAPI(`/admin/farms/${farmId}/bins/${binId}`, {
    method: 'DELETE'
  });
};

export const getFasStatus = (farmId) => {
  return fetchFromAPI(`/admin/farms/${farmId}/bins/fas_status`)
    .then((response) => response)
    .catch(() => ({ has_fas_integration: false }));
};

export const getFarmPigMigrations = (id, params) => {
  return fetchFromAPI(`/farms/${id}/pig_migrations`, { params })
    .catch((response) => {
      throw response;
    });
};

export const makeFarmCheckIn = (farmId) => {
  return fetchFromAPI(`/farms/${farmId}/check_ins`, { method: 'post' })
    .then((response) => response.resource);
};

export const getFarmSiteVisitReports = (farmId, params) => {
  return fetchFromAPI(`/farms/${farmId}/svrs`, { params });
};

export const searchFarms = (params) => {
  return fetchFromAPI('/farms/search', { params });
};
